



















import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { sanitizeLinkUrl } from '@shared/helpers/sanitizeLinkUrl';
import { CSSClass } from '@shared/types/vue';
import { BaseButton, UCIcon } from '@shared/ui';

import { IMegaMenuCard } from '../NavigationExpandedMenu/MegaMenuCard.vue';

interface INavigationMenuItemLink {
  cached_url: string;
  url: string;
}

export interface INavigationMenuItem {
  _uid: string;
  label: string;
  link: INavigationMenuItemLink;
  items?: INavigationMenuItem[];
  cards_title?: string;
  cards?: IMegaMenuCard[];
}

export default defineComponent({
  name: 'NavigationMenuItem',
  components: {
    BaseButton,
    UCIcon,
  },
  props: {
    navigationMenuItem: {
      type: Object as PropType<INavigationMenuItem>,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const scrollRight = () => {
      emit('scroll-right');
    };

    const toggleMenu = () => {
      if (props.isActive) {
        emit('close-menu-item', props.level);
      } else {
        emit('open-menu-item', props.navigationMenuItem._uid, props.level);
        scrollRight();
      }
    };

    const closeMenus = (): void => {
      emit('close-menus');
    };

    const hasItems = computed(() => !!props.navigationMenuItem?.items?.length);

    const menuButtonClasses = computed((): CSSClass[] => {
      const baseClass = 'navigation-menu-item__menu-button';
      const activeClass = `${baseClass}--active`;

      return [
        'sf-button--pure',
        baseClass,
        {
          [activeClass]: props.isActive,
        },
      ];
    });

    const listClasses = computed((): CSSClass[] => {
      const baseClass = 'navigation-menu-item__list';
      const activeClass = `${baseClass}--active`;

      return [
        baseClass,
        {
          [activeClass]: props.isActive,
        },
      ];
    });

    const linkURL = computed((): string => {
      return sanitizeLinkUrl(props.navigationMenuItem?.link?.cached_url);
    });

    return {
      hasItems,
      menuButtonClasses,
      listClasses,
      linkURL,
      scrollRight,
      toggleMenu,
      closeMenus,
    };
  },
});
